import axios from "axios";
const axiosInstance = axios.create({
  baseURL: "https://assignment7-jobfinder-server-tanviranindo.glitch.me",
  // baseURL: "https://assignment7-jobfinder-server-tanviranindo.onrender.com",
  // baseURL: "http://localhost:9000",
});
export default axiosInstance;